import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { EMPTY, Observable, retry, timer} from 'rxjs';
import {
    catchError,
} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState} from "@store/state/app.state";
import {setNotification} from "@store/actions/global.actions";
import {logout} from "@store/actions/authentication.action";
import {PlatformService} from "@iw-shop/core/services/platform-service";
@Injectable()
export class OfflineInterceptor implements HttpInterceptor {

    constructor(private store: Store<AppState>, protected platformService: PlatformService) {

    }




    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retry({
                count: 3, // retry up to 3 times
                delay: (error, retryAttempt) => timer(2000), // delay 2 seconds before retry
                resetOnSuccess: false
            }),


            catchError(err => {
                if (err.status === 401) {

                    if(this.platformService.isBrowser){
                        window.location.reload();
                        this.store.dispatch(logout());
                    }

                } else {
                    this.store.dispatch(setNotification({
                        notification: 'Bitte prüfen Sie Ihre Internetverbindung.',
                        notificationType: 'error'
                    }));
                }

                    // You can handle final errors here
                //console.error('Request ultimately failed', err);
                return EMPTY;
            })
        );
    }
}
